// extracted by mini-css-extract-plugin
export default {"wrapper":"FormButtonWrapper_wrapper__kgPmx"};